import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {faSignOutAlt, faSync, faUser, faPaperPlane, faUpload} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import apiClient from "@/services/apiClient";
import { BootstrapVue3 } from "bootstrap-vue-3";
import 'bootstrap/dist/css/bootstrap.css';
import Notifications from '@kyvg/vue3-notification'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import { createPinia } from "pinia";
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
library.add(faSignOutAlt, faUser, faSync, faPaperPlane, faUpload);
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
const pinia = createPinia();
app.use(Notifications)
app.use(BootstrapVue3)
app.config.globalProperties.$http = apiClient;
app.use(router);
app.use(ElementPlus);
app.use(BootstrapVue3);
app.component("font-awesome-icon", FontAwesomeIcon);
app.use(pinia);
app.mount("#app");
